export { default as UniversalLink } from './UniversalLink';
export type { UniversalLinkFields } from './UniversalLink';
